export default __webpack_public_path__ + "static/media/14.a592ec9b.png";